// 2024 Command (SRD 5.2): what a creature that failed its Wisdom save does on its next turn.
export const COMMAND_EFFECTS = Object.freeze({
  approach: 'moves toward the caster by the shortest and most direct route, ending its turn if it moves within 5 feet of them',
  drop: 'drops whatever it is holding and then ends its turn',
  flee: 'spends its turn moving away from the caster by the fastest available means',
  grovel: 'has the Prone condition and then ends its turn',
  halt: "doesn't move and takes no action or Bonus Action",
});
export const COMMAND_EFFECT_ID = 'spell:command';

/** The Command effect a creature must follow, with its chosen word, or null. */
export const activeCommand = (activeEffects, combatantId) => (Array.isArray(activeEffects) ? activeEffects : [])
  .find(effect => effect?.definitionId === COMMAND_EFFECT_ID && effect.targetCombatantId != null
    && String(effect.targetCombatantId) === String(combatantId) && effect.choice?.command) || null;

/** "Ghoul must halt: doesn't move and takes no action or Bonus Action." */
export const commandReminder = (name, command) => `${name} must ${command}: ${COMMAND_EFFECTS[command] || 'follow the command'}.`;

/** Command lasts until the end of the target's next turn (it fails its save before that turn). */
export const commandExpiration = targetCombatantId => ({ type: 'targetTurn', combatantId: String(targetCombatantId), boundary: 'end', remainingOccurrences: 1 });
